import { ChatMessage } from "@/components/chat/types";
import {
  transformChatMessageData,
  transformSingleChatMessageData,
} from "./chatUtilsService";
import { chatService } from "@/services/chatService";

/**
 * Fetch chat messages for a specific chat
 */
export const fetchChatMessages = async (
  chatId: string
): Promise<ChatMessage[]> => {
  try {
    console.log("Fetching messages for chat:", chatId);

    const response = await chatService.getMessages(chatId);

    // API returns data directly
    const messages = Array.isArray(response) ? response : (response?.messages || []);

    if (messages.length === 0) {
      console.log("No messages found for chat:", chatId);
      return [];
    }

    // Backend already includes user data, just transform if needed
    return transformChatMessageData(messages);
  } catch (error) {
    console.error("Failed to fetch chat messages", error);
    return [];
  }
};

/**
 * Send a new chat message
 */
export const sendChatMessage = async (
  chatId: string,
  senderId: string,
  recipientId: string,
  content: string
): Promise<ChatMessage | null> => {
  try {
    console.log("Sending message to chat:", chatId, "from user:", senderId);

    const data = await chatService.sendMessage(chatId, { content });

    if (!data) {
      console.error("Error sending message: No data returned");
      return null;
    }

    // Transform response to ChatMessage format
    return transformSingleChatMessageData(data);
  } catch (error) {
    console.error("Failed to send chat message", error);
    return null;
  }
};
